<template>
  <div>
    <v-dialog
      scrollable
      :fullscreen="this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs"
      v-model="dialog"
      max-width="900"
    >
      <newOfferWizard @closeDialog="dialog = false" />
    </v-dialog>

    <integratedSearchBar
      :button_display="currentUserCan('create', 'offer')"
      button_type="function"
      :button_function="button_function"
      button_label="Add a new offer"
      :button_show_label="false"
      :dialog.sync="dialog"
      v-bind:search.sync="search"
      search_label="Search offers..."
    />
    <v-data-table
      :headers="headers"
      :items="offers"
      :search="search"
      :pagination.sync="pagination"
      :loading="loading"
      :expand="expand"
      flat
      rows-per-page-text="Offers per page"
    >
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template slot="items" slot-scope="props" class="px-2">
        <tr @click="props.expanded = !props.expanded">
          <td>{{ props.item.company.name }}</td>
          <td v-if="!props.item.product_packagings_entities.length">
            No product
          </td>
          <td v-else>
            {{
              props.item.product_packagings_entities.length +
              " product" +
              (props.item.product_packagings_entities.length > 1 ? "s" : "")
            }}
            <v-icon small class="pl-2">keyboard_arrow_down</v-icon>
          </td>
          <!-- <td>{{ props.item.product_packagings_entities.length+' product'+ props.item.product_packagings_entities.length>1 ? "s" :""}}<v-icon small class="pl-2">keyboard_arrow_down</v-icon>  </td> -->
          <td>
            <flag
              v-if="props.item.port"
              :iso="props.item.port.country.iso_code"
            />
            <span class="pl-1">{{
              props.item.port && props.item.port.name
            }}</span>
          </td>

          <td class="px-0">
            <v-layout row align-center justify-center>
              <v-tooltip left v-if="props.item.opportunity">
                <span slot="activator">
                  <v-icon small size="14" class="pr-1 grey--text">help</v-icon>
                  {{
                    props.item.opportunity &&
                    props.item.opportunity.company_ids.length
                  }}
                </span>
                <span>
                  <h3>
                    {{
                      props.item.opportunity.company_ids.length +
                      (props.item.opportunity.company_ids.length > 1
                        ? " customers"
                        : " customer") +
                      " interested:"
                    }}
                  </h3>
                  <template v-for="c in props.item.opportunity.companies">
                    <span :key="c.name">
                      <v-icon small dark class="pr-2">store</v-icon>
                      <span>{{ c.name }}</span>
                      <br />
                    </span>
                  </template>
                </span>
              </v-tooltip>
            </v-layout>
          </td>
          <td>{{ props.item.created_at }}</td>
          <td class="px-0">
            <v-layout row align-center justify-center>
              <salesforceSyncer :offerDemand="props.item" :isOffer="true" />
            </v-layout>
          </td>
          <td class="px-0">
            <v-layout row align-center justify-center>
              <destroyModale
                resourceName="offer"
                :itemId="props.item.id"
                warningText="You are going to remove this offer permanently"
                small
              />
            </v-layout>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="product_headers"
              :items="props.item.product_packagings_entities"
              :pagination="product_pagination"
              hide-actions
              hide-headers
              flat
            >
              <template slot="items" slot-scope="products_props" class="px-2">
                <td>
                  <v-icon small class="pr-2" color="grey lighten1"
                    >shopping_cart</v-icon
                  >
                  {{ products_props.item.product.name }}
                </td>

                <td>
                  <template
                    v-for="(pr, index) in products_props.item.packagings"
                  >
                    <span :key="index" class="caption">
                      <br v-if="index > 0" />
                      <v-icon small class="pr-2" color="grey lighten1"
                        >mdi-package-variant</v-icon
                      >
                      {{ pr.name }}
                    </span>
                  </template>
                </td>
                <td>
                  <v-icon small class="pr-2" color="grey lighten1"
                    >mdi-scale-balance</v-icon
                  >
                  {{ products_props.item.weight_mt }}mt
                </td>
                <td @click="edit(products_props.index, products_props.item)">
                  <div v-if="editedItem == products_props.index">
                    <v-text-field
                      name="price"
                      type="number"
                      v-model="currentPrice"
                    ></v-text-field>
                  </div>

                  <div v-else>
                    <v-icon small class="pr-2" color="grey lighten1"
                      >attach_money</v-icon
                    >
                    {{ products_props.item.price + props.item.currency.name }}
                  </div>
                </td>
                <div v-if="editedItem === products_props.index">
                  <v-layout row>
                    <v-btn fab flat @click="updatePrice(products_props.item)">
                      <v-icon color="success">done</v-icon>
                    </v-btn>
                    <v-btn fab flat @click="endEdit">
                      <v-icon color="error">clear</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
              </template>
              <template v-slot:no-data
                >Sorry, there is no product to display here.</template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OFFERS_INDEX from "../../graphql/offers/index.gql";
import OFFERS_UPDATE from "../../graphql/offers/update.gql";
import UPDATE_PRODUCT_PACKAGINGS_ENTITY from "../../graphql/product_packagings_entities/update.gql";
import integratedSearchBar from "../shared/integratedSearchBar";
import newOfferWizard from "./newOfferWizard";
import salesforceSyncer from "./salesforceSyncer";

export default {
  computed: {
    ...mapGetters("companyStore", ["offers"]),
  },
  components: { integratedSearchBar, newOfferWizard, salesforceSyncer },
  data() {
    return {
      dialog: false,
      loading: false,
      expand: false,
      currentPrice: 0,
      editedItem: -1,
      pagination: {
        descending: true,
        rowsPerPage: 25,
        sortBy: "created_at",
      },
      product_pagination: {
        descending: true,
        rowsPerPage: -1,
        sortBy: "created_at",
      },
      search: "",
      product_headers: [
        {
          text: "Product",
          align: "left",
          sortable: false,
          value: "product.name",
        },
        {
          text: "Packagings",
          align: "left",
          sortable: false,
          value: "product.packaging.name",
        },
        {
          text: "Weight (mt)",
          align: "left",
          sortable: false,
          value: "weight_mt",
        },
        {
          text: "Price",
          align: "left",
          sortable: false,
          value: "price",
        },
      ],
      headers: [
        {
          text: "Supplier",
          align: "left",
          sortable: true,
          value: "company.name",
          width: "25%",
        },
        {
          text: "Products",
          align: "left",
          sortable: true,
          value: "search",
          width: "15%",
        },
        {
          text: "Port of Loading",
          align: "left",
          sortable: true,
          value: "port.name",
          width: "15%",
        },
        {
          text: "Potential Customers",
          align: "left",
          sortable: true,
          value: "",
          width: "1%",
        },
        {
          text: "Created At",
          align: "left",
          sortable: true,
          value: "created_at",
          width: "19%",
        },
        {
          text: "Salesforce Sync",
          align: "center",
          sortable: true,
          value: "salesforce_sync",
          width: "10%",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          width: "10%",
        },
      ],
    };
  },
  created() {
    this.subscribe(OFFERS_INDEX, null, "companyStore", "offers");
  },
  beforeDestroy() {
    this.unsubscribe("offers");
  },
  methods: {
    updatePrice(p) {
      this.sendMutation("updated", "price", UPDATE_PRODUCT_PACKAGINGS_ENTITY, {
        id: p.id,
        price: parseFloat(this.currentPrice),
      })
        .then((data) => {
          p.price = data.update_product_packagings_entity.price;
          this.endEdit();
        })
        .catch(() => {
          this.endEdit();
        });
    },
    endEdit() {
      this.editedItem = -1;
    },
    edit(index, ppe) {
      if (this.editedItem !== index) {
        if (this.editedItem >= 0) {
          this.editedItem = -1;
        } else {
          this.editedItem = index;
          this.currentPrice = ppe.price;
        }
      }
    },
    button_function() {
      this.dialog = true;
    },
  },
};
</script>
<style lang="stylus">
div.v-table__overflow > table > tbody > tr > td.center > div > div {
  margin-top: 16px !important;
}
</style>
